import { useEffect, useState } from 'react';
import { skipToken } from '@reduxjs/toolkit/query';
import { EvalRunStatus, EvalSubject, useGetLatestEvalQuery } from '../api/aiPromptApi';

/**
 * Latest eval for a subject, polling while a run or a fix proposal is in
 * flight so callers (the editor's badge and the eval modal) flip to the
 * result on their own.
 */
export const useLatestEval = (subject: EvalSubject | null) => {
  const [pollingInterval, setPollingInterval] = useState(0);
  const query = useGetLatestEvalQuery(subject ?? skipToken, { pollingInterval });

  const run = query.data?.eval_run ?? null;
  const isActive =
    !!run && (run.status === EvalRunStatus.Pending || run.status === EvalRunStatus.Running);
  const isProposing = !!run && run.proposal_status === 'pending';

  useEffect(() => {
    setPollingInterval(isActive || isProposing ? 3000 : 0);
  }, [isActive, isProposing]);

  return { ...query, run, isActive, isProposing };
};
